// extracted by mini-css-extract-plugin
module.exports = {"container":"Day_container__2PW6q","title":"Day_title__1ZhnJ","challenge":"Day_challenge__W2XYZ","completed":"Day_completed__qFRJU","half":"Day_half__3Nl2O"};